import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/betgalaxy/images/logo.svg';

export default function index() {
  return <Image src={logo} maxW={['200px', null, '240px']} />;
}
